import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./PlayingTime.module.scss";
import {usePlayingTimeLogic} from "./PlayingTime.logic";
import {PlayingTimeDurationSwitcher} from "../playing-time-duration-switcher/PlayingTimeDurationSwitcher";
import BreakdownSection from "../../../components/dashboard/BreakdownSection";

export const PlayingTime: VoidFunctionComponent = () => {
  const {courses, songs, bootcamp, summary} = usePlayingTimeLogic();
  const totalPlayedMilliseconds = calculateTotalMilliseconds(courses?.actualMilliseconds ?? 0, songs?.actualMilliseconds ?? 0, bootcamp?.actualMilliseconds ?? 0);

  return (
    <section className={s.container}>
      <div className={s.titleAndDuration}>
        <h2>Playing time</h2>
        <PlayingTimeDurationSwitcher />
      </div>
      <div className={s.timeBreakdown}>
        <BreakdownSection
          icon={`icon-bootcamp`}
          barLabel={`Bootcamp`}
          totalValue={totalPlayedMilliseconds}
          barValue={bootcamp?.actualMilliseconds ?? 0}
          barValueLabel={bootcamp?.wholeHours}
          barValueUnit={bootcamp?.hoursLabel}
          barSubValueLabel={bootcamp?.wholeRemainderMinutes}
          barSubValueUnit={bootcamp?.minutesLabel}
        />
        <BreakdownSection
          icon={`icon-courses`}
          barLabel={'Courses'}
          totalValue={totalPlayedMilliseconds}
          barValue={courses?.actualMilliseconds ?? 0}
          barValueLabel={courses?.wholeHours}
          barValueUnit={courses?.hoursLabel}
          barSubValueLabel={courses?.wholeRemainderMinutes}
          barSubValueUnit={courses?.minutesLabel}
        />
        <BreakdownSection
          icon={`icon-songs`}
          barLabel={`Songs`}
          totalValue={totalPlayedMilliseconds}
          barValue={songs?.actualMilliseconds ?? 0}
          barValueLabel={songs?.wholeHours}
          barValueUnit={songs?.hoursLabel}
          barSubValueLabel={songs?.wholeRemainderMinutes}
          barSubValueUnit={songs?.minutesLabel}
        />
      </div>
      <div className={s.totals}>
        <h3>{summary?.wholeHours ?? 0} <span className={s.unit}>hours</span></h3>
        <h3>{summary?.wholeMinutes ?? 0} <span className={s.unit}>minutes</span></h3>
      </div>
    </section>
  );

  function calculateTotalMilliseconds(courses: number, songs: number, bootcamp: number): number {
    return courses + songs + bootcamp;
  }
}
